import React from "react";
import { Block, Sub, N, Conv, Bar, th, thr, td, tdr } from "./shared";
import { fmtEur, fmtPct } from "../labels";

function Row({ r, drill, bold }) {
  const ag = r.agent_email || "__none__";
  const cls = bold ? "font-semibold border-t-2 border-clay-300" : "border-b border-clay-100";
  return (
    <tr className={cls} data-testid={bold ? "kk-agents-total" : `kk-agent-row-${ag}`}>
      <td className={`${td} font-medium`}>{r.agent_name || "Empresa"}</td>
      <td className={tdr}><N value={r.sales_count} onClick={drill && (() => drill({ agent: ag, bucket: "sold", all_time: true }))} tone="text-emerald-800"/>{r.pre_cohort_sold ? <span className="text-[10px] text-clay-500" title="leads de antes de 2026 reservados este año"> ({r.pre_cohort_sold} de 2025)</span> : null}</td>
      <td className={tdr}>{fmtEur(r.sales_eur)}</td>
      <td className={tdr}>{fmtEur(r.net_eur)}</td>
      <td className={tdr}>{fmtEur(r.margin_eur)}</td>
      <td className={tdr}>{fmtPct(r.margin_pct)}</td>
      <td className={tdr}>{fmtEur(r.avg_ticket)}</td>
      <td className={tdr}>{fmtEur(r.avg_margin)}</td>
      <td className={tdr}><N value={r.leads} onClick={drill && (() => drill({ agent: ag }))}/></td>
      <td className={tdr}><Conv value={r.conversion}/></td>
      <td className={`${tdr} text-[10px] text-clay-500`}>{r.no_breakdown ? `${r.no_breakdown} sin desglose` : ""}</td>
    </tr>
  );
}

function Monthly({ monthly }) {
  const rows = monthly.filter((m) => m.month !== "?");
  const max = Math.max(...rows.map((m) => m.sales_eur), 1);
  return (
    <div className="overflow-x-auto">
      <table className="text-[12px]" data-testid="kk-agents-monthly">
        <thead><tr className="border-b border-clay-300"><th className={th}>Mes de reserva</th><th className={thr}>Ventas</th><th className={thr}>Venta</th><th className={thr}>Ingreso neto</th><th className={thr}>Margen</th></tr></thead>
        <tbody>
          {rows.map((m) => (
            <tr key={m.month} className="border-b border-clay-100">
              <td className={td}>{m.month}</td><td className={tdr}>{m.sold}</td>
              <td className={tdr}><Bar value={m.sales_eur} max={max}/> {fmtEur(m.sales_eur)}</td>
              <td className={tdr}>{fmtEur(m.net_eur)}</td><td className={tdr}>{fmtEur(m.margin_eur)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function AgentsBlock({ data, drill }) {
  return (
    <Block id="agents" title="Ventas por agente" subtitle="venta = precio al viajero · neto = sin comisión ni tasas KimKim · margen = markup declarado en la propuesta">
      <div className="overflow-x-auto">
        <table className="w-full text-[12px]" data-testid="kk-agents-table">
          <thead><tr className="border-b border-clay-300">
            <th className={th}>Agente</th><th className={thr}>Ventas</th><th className={thr}>Venta total</th><th className={thr}>Ingreso neto</th><th className={thr}>Margen</th><th className={thr}>Margen %</th>
            <th className={thr}>Ticket medio</th><th className={thr}>Margen medio</th><th className={thr}>Leads</th><th className={thr}>Conversión</th><th className={th}/>
          </tr></thead>
          <tbody>
            {data.rows.map((r) => <Row key={r.agent_email || "none"} r={r} drill={drill}/>)}
            <Row r={data.total} bold/>
          </tbody>
        </table>
      </div>
      <Sub title="Evolución mensual" hint="por fecha de reserva · toda la empresa"><Monthly monthly={data.monthly}/></Sub>
    </Block>
  );
}
